import 'react-app-polyfill/ie11';
import 'es6-symbol/implement';
// @ts-ignore
import values from 'object.values';
// @ts-ignore
import entries from 'object.entries';

// Needed for ios12 mobile safari
require('intersection-observer');

// Polyfills
if (!Object.values) {
  values.shim();
}
if (!Object.entries) {
  entries.shim();
}
if (!Element.prototype.matches) {
  Element.prototype.matches = (Element.prototype as any).msMatchesSelector;
}
